import { scrollToTop } from "../../../utils/helpers/helperMethods/scrollToTop";
import { AppDispatch } from "../../../slices/store";
import { editUser } from "../../../slices/users/userManagementSlice";

export const handleEditUser = (
    data:any,
    dispatch: AppDispatch,
    setIsLoading:any,
    addAlert: Function,
    shouldRedirect:boolean,
    navigate: Function,
    protectedResources: any,
    url: string,
    reqRequests: any,
    getClients: any,
  ) =>{
    const params = {
      user: data,
      accessToken: localStorage.getItem('AccessToken') || "",
      url: url,
      imageURL: "",
      selectedFile: null,
  
    }
  
    dispatch(editUser(params)).then((r:any) => {
      scrollToTop();
      if (r?.payload?.status  === "success"){
        addAlert("User Edited Successfully", "success", true);
        dispatch(getClients(reqRequests)).then((r :any)=>{
          if (r.payload.succeeded) {
            setIsLoading(false);
            if (shouldRedirect){
              navigate(-1);
            }
          }
        })
      }
    }).catch(e => {
      setIsLoading(false);
      addAlert("Customer Edit Failed", "failed", true);
    })
  }
  